define('requester/template',[], function () {
    "use strict";
    function isUndefined(value) {
        return value === undefined;
    }

    function isFunction(value) {
        return typeof value === 'function';
    }

    return function (template, values) {
        return template.replace(/\{ *([\w_]+) *\}/g, function (match, key) {
            var value = values[key];
            if (isUndefined(value)) {
                return "{" + key + "}";
            } else if (isFunction(value)) {
                return value(key);
            }
            return value;
        });
    };
});

